import { FACT_ATTRIBUTE_IDS, FACT_IDS } from '../../components/Shared/Factsheet/constants'

const putFactsheet = (factsheet) => ({
  type: 'FACTSHEET_PUT',
  payload: {
    factsheet
  }
})

const addFactInstance = (factDefId, data) => ({
  type: 'FACTSHEET_ADD_FACT_INSTANCE',
  payload: {
    factDefId,
    data
  }
})

const putFactInstance = (factDefId, factInstanceKey, data) => ({
  type: 'FACTSHEET_PUT_FACT_INSTANCE',
  payload: {
    factDefId,
    factInstanceKey,
    data
  }
})

const deleteFactInstance = (factDefId, factInstanceKey) => ({
  type: 'FACTSHEET_DELETE_FACT_INSTANCE',
  payload: {
    factDefId,
    factInstanceKey
  }
})

const deleteFact = (factDefId) => ({
  type: 'FACTSHEET_DELETE_FACT',
  payload: {
    factDefId
  }
})

const putAttribute = (factDefId, factInstanceKey, attributeDefId, data) => ({
  type: 'FACTSHEET_PUT_ATTRIBUTE',
  payload: {
    factDefId,
    factInstanceKey,
    attributeDefId,
    data
  }
})

const deleteAttribute = (factDefId, factInstanceKey, attributeDefId) => ({
  type: 'FACTSHEET_DELETE_ATTRIBUTE',
  payload: {
    factDefId,
    factInstanceKey,
    attributeDefId
  }
})

const putValidationStatus = (factDefId, factInstanceKey, attributeDefId, isValid) => ({
  type: 'FACTSHEET_PUT_VALIDATION_STATUS',
  payload: {
    factDefId,
    factInstanceKey,
    attributeDefId,
    isValid
  }
})

const putFactInstanceExpandedStatus = (factDefId, factInstanceKey, expanded) => ({
  type: 'FACTSHEET_PUT_FACT_INSTANCE_EXPANDED_STATUS',
  payload: {
    factDefId,
    factInstanceKey,
    expanded
  }
})

const putCountryCodeFact = (countryCode) => {
  return (dispatch) => {
    dispatch(putAttribute(
      String(FACT_IDS.COUNTRY),
      0,
      String(FACT_ATTRIBUTE_IDS.COUNTRY_CODE),
      {
        attributeDefId: String(FACT_ATTRIBUTE_IDS.COUNTRY_CODE),
        value: countryCode,
      }
    ))
  }
}

const putBlueprint = (blueprint) => ({
  type: 'FACTSHEET_PUT_BLUEPRINT',
  payload: {
    blueprint
  }
})

export const factsheetActions = {
  putFactsheet,
  addFactInstance,
  putFactInstance,
  deleteFactInstance,
  deleteFact,
  putAttribute,
  deleteAttribute,
  putValidationStatus,
  putFactInstanceExpandedStatus,
  putCountryCodeFact,
  putBlueprint,
}
